import { render, staticRenderFns } from "./FormControlInsightCategory.vue?vue&type=template&id=b4d70582"
import script from "./FormControlInsightCategory.vue?vue&type=script&lang=js"
export * from "./FormControlInsightCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b4d70582')) {
      api.createRecord('b4d70582', component.options)
    } else {
      api.reload('b4d70582', component.options)
    }
    module.hot.accept("./FormControlInsightCategory.vue?vue&type=template&id=b4d70582", function () {
      api.rerender('b4d70582', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Form/Control/FormControlInsightCategory.vue"
export default component.exports